import React from 'react'
import { useLiveNotificationBanner } from '@src/components/notifications/hooks/useLiveNotificationBanner'
import { StyleService, useStyleSheet } from '@src/style/service'
import { NotificationEngineScreen } from '@src/types'
import { BaseLiveSurfaceBannerBody } from './BaseLiveSurfaceBannerBody'

interface LiveSurfaceBannerProps {
  screen: NotificationEngineScreen
}

export const LiveSurfaceBanner = ({ screen }: LiveSurfaceBannerProps) => {
  const styles = useStyleSheet(themedStyles)
  const bannerProps = useLiveNotificationBanner({ screen })

  if (!bannerProps) {
    return null
  }

  return (
    <BaseLiveSurfaceBannerBody
      {...bannerProps}
      style={styles.bannerStyle}
      testIdPrefix="NotificationBanner/LiveSurface"
    />
  )
}

const themedStyles = StyleService.create({
  bannerStyle: {
    marginTop: 16,
    marginBottom: 8,
    marginHorizontal: 16,
  },
})
